/**
 * @source https://github.com/zloirock/core-js/blob/a13dc999ab53acf4e86885d78c6dd68322964d63/modules/core.regexp.escape.js#L5
 * @returns {string}
 */
const regexEscape = (str: string) => String(str).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');

// @ts-ignore
if (typeof RegExp !== 'undefined' && typeof RegExp.escape !== 'function') {
    // @ts-ignore
    RegExp.escape = regexEscape;
}

export default regexEscape;
